var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('InputCode',{attrs:{"language":"markdown","height":"40vh"},on:{"blur":_vm.sanitize},model:{value:(_vm.buffer.markdownContent),callback:function ($$v) {_vm.$set(_vm.buffer, "markdownContent", $$v)},expression:"buffer.markdownContent"}})}
var staticRenderFns = []

export { render, staticRenderFns }